// extracted by extract-css-chunks-webpack-plugin
module.exports = {"qbo-heading":"styles__qbo-heading___1Hz7J","qboHeading":"styles__qbo-heading___1Hz7J","qbo-title":"styles__qbo-title___2r1zC","qboTitle":"styles__qbo-title___2r1zC","qbo-edit-link":"styles__qbo-edit-link___3WxkL","qboEditLink":"styles__qbo-edit-link___3WxkL","panel-footer":"styles__panel-footer___3dUqq","panelFooter":"styles__panel-footer___3dUqq"};
    if(module.hot) {
      // 1679619793132
      var cssReload = require("../../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  